export default __webpack_public_path__ + "static/media/mainBanner.38ca234f.png";